import Axios from 'axios'
import QS from 'qs'
const devEnv = require('../config/dev.env.js')
const prodEnv = require('../config/prod.env.js')
const testEnv = require('../config/test.env.js')
import router from './router'
const env = process.env.VUE_APP_MODE === 'development' ? devEnv : (process.env.VUE_APP_MODE === 'test' ? testEnv : prodEnv)
const Service = {
    install: (Vue) => {
        const instance = Axios.create({
            baseURL: env.API_URL,
            timeout: 30000,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        })
        // 添加请求拦截器
        instance.interceptors.request.use(config => {
            config.headers.common['token'] = localStorage.getItem('rosetoken')
            return config
        })
        // 添加响应拦截器
        instance.interceptors.response.use(response => {
            if (response.status === 200 && response.data) {
                if (response.data.code === 500 && response.data.status === -5) {
                    localStorage.removeItem('rosetoken')
                    var redirectUrl = router.currentRoute.fullPath.substring(1, router.currentRoute.fullPath.length)
                    router.replace({
                        path: '/login',
                        query: { redirect: redirectUrl }
                    })
                }
            }
            return response
        }, error => {
            return Promise.reject(error)
        })
        Vue.prototype.$http = instance
        Vue.prototype.qs = QS
        Vue.prototype.apis = env.API_URL
        Vue.prototype.apip = env.APIP_URL
        Vue.prototype.apiw = env.APIW_URL
        Vue.prototype.apih = env.APIH_URL
        Vue.prototype.apath = env.PATH_URL
        Vue.prototype.apit = env.APIT_URL
    }
}
export default Service
